const subData = {
  subjects: [
    {
      subCode: 3161608,
      content: [
        { chName: "What is AI?", chapterNo: 1 },
        {
          chName: "Problems, State Space Search & Heuristic Search Techniques",
          chapterNo: 2,
        },
        { chName: "Logical Agents", chapterNo: 3 },
        { chName: "Inference in First Order Logic", chapterNo: 4 },
        { chName: "Uncertainty", chapterNo: 5 },
        { chName: "Probabilistic Reasoning", chapterNo: 6 },
        { chName: "Game Playing: Overview, and Example Domain", chapterNo: 7 },
        { chName: "Statistical Learning Methods", chapterNo: 8 },
        { chName: "Introduction to Prolog", chapterNo: 9 },
      ],
    },
    {
      subCode: 3161612,
      content: [
        { chName: "Overview of AndrochapterNo", chapterNo: 1 },
        {
          chName: "Using Activities, Fragments and Intents in AndrochapterNo",
          chapterNo: 2,
        },
        {
          chName: "Working with the User Interface Using Vies and ViewGroups",
          chapterNo: 3,
        },
        { chName: "Storing the Data Persistently", chapterNo: 4 },
        { chName: "Working with Location Services and Maps", chapterNo: 5 },
        { chName: "Working with Graphics and Animation", chapterNo: 6 },
        { chName: "Audio, VchapterNoeo and Camera", chapterNo: 7 },
        { chName: "Publishing and Distributing AndrochapterNo Application", chapterNo: 8 },
      ],
    },
    {
      subCode: 3161610,
      content: [
        { chName: "Data Warehousing", chapterNo: 1 },
        {
          chName: "Introduction to data mining (DM)",
          chapterNo: 2,
        },
        {
          chName: "Data Pre-processing",
          chapterNo: 3,
        },
        {
          chName: "Mining Frequent Patterns, Associations and Correlations",
          chapterNo: 4,
        },
        { chName: "Classification and Prediction", chapterNo: 5 },
        { chName: "Cluster Analysis", chapterNo: 6 },
        { chName: "Advance topics", chapterNo: 7 },
      ],
    },
    {
      subCode: 3161609,
      content: [
        { chName: "Introduction", chapterNo: 1 },
        {
          chName: "Symmetric Cipher Model",
          chapterNo: 2,
        },
        {
          chName: "Stream ciphers and block ciphers",
          chapterNo: 3,
        },
        {
          chName: "Multiple encryption and triple DES",
          chapterNo: 4,
        },
        { chName: "Public Key Cryptosystems with Applications", chapterNo: 5 },
        { chName: "Cryptographic Hash Functions", chapterNo: 6 },
        { chName: "Message Authentication Codes", chapterNo: 7 },
        { chName: "Digital Signature", chapterNo: 8 },
        { chName: "Key management and distribution", chapterNo: 9 },
        {
          chName:
            "Remote user authentication with symmetric and asymmetric encryption",
          chapterNo: 10,
        },
        {
          chName: "Web Security threats and approaches",
          chapterNo: 11,
        },
      ],
    },
    {
      subCode: 3161605,
      content: [
        { chName: "Introduction to Software and Software Engineering", chapterNo: 1 },
        {
          chName: "Agile Development",
          chapterNo: 2,
        },
        {
          chName: "Managing Software Project",
          chapterNo: 3,
        },
        {
          chName: "Requirement Analysis and Specification",
          chapterNo: 4,
        },
        {
          chName: "Software Design",
          chapterNo: 5,
        },
        { chName: "Software Coding & Testing", chapterNo: 6 },
        { chName: "Quality Assurance and Management ", chapterNo: 7 },
        { chName: "Software Maintenance and Configuration Management", chapterNo: 8 },
        { chName: "DevOps", chapterNo: 9 },
        { chName: "Advanced Topics in Software Engineering", chapterNo: 10 },
      ],
    },
  ],
};

export default subData;
